import { createSlice } from '@reduxjs/toolkit';
import { fetchPackagingUnitDocuments, uploadPackagingUnitDocuments, deletePackagingUnitDocument } from '../actions/packagingUnitDocument';

const packagingUnitDocumentSlice = createSlice({
    name: 'packagingUnitDocument',
    initialState: {
        loading: false,
        uploading: false,
        data: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPackagingUnitDocuments.pending, (state) => { state.loading = true; })
            .addCase(fetchPackagingUnitDocuments.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPackagingUnitDocuments.rejected, (state) => { state.loading = false; })

            .addCase(uploadPackagingUnitDocuments.pending, (state) => { state.uploading = true; })
            .addCase(uploadPackagingUnitDocuments.fulfilled, (state, action) => {
                state.uploading = false;
                state.data = action.payload;
            })
            .addCase(uploadPackagingUnitDocuments.rejected, (state) => { state.uploading = false; })

            .addCase(deletePackagingUnitDocument.pending, (state) => { state.loading = true; })
            .addCase(deletePackagingUnitDocument.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(deletePackagingUnitDocument.rejected, (state) => { state.loading = false; });
    },
});

export default packagingUnitDocumentSlice.reducer;
